import { render, staticRenderFns } from "./RedirectTan.vue?vue&type=template&id=6093d310&scoped=true"
import script from "./RedirectTan.vue?vue&type=script&lang=js"
export * from "./RedirectTan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6093d310",
  null
  
)

export default component.exports